__turbopack_context__.v({
  "timeTracker": "_0Px3TW_timeTracker",
  "timeTrackerIcon": "_0Px3TW_timeTrackerIcon",
  "timeTrackerIconActive": "_0Px3TW_timeTrackerIconActive",
  "timeTrackerManual": "_0Px3TW_timeTrackerManual",
  "timeTrackerSummary": "_0Px3TW_timeTrackerSummary",
  "timeTrackerSummary__action": "_0Px3TW_timeTrackerSummary__action",
  "timeTrackerSummary__actions": "_0Px3TW_timeTrackerSummary__actions",
  "timeTrackerSummary__content": "_0Px3TW_timeTrackerSummary__content",
  "timeTrackerSummary__meta": "_0Px3TW_timeTrackerSummary__meta",
  "timeTrackerSummary__title": "_0Px3TW_timeTrackerSummary__title",
  "timeTrackerTimer": "_0Px3TW_timeTrackerTimer",
  "timeTracker__closeAction": "_0Px3TW_timeTracker__closeAction",
  "timeTracker__datePicker": "_0Px3TW_timeTracker__datePicker",
  "timeTracker__delta": "_0Px3TW_timeTracker__delta",
  "timeTracker__elapsed": "_0Px3TW_timeTracker__elapsed",
  "timeTracker__formatButtons": "_0Px3TW_timeTracker__formatButtons",
  "timeTracker__manualControls": "_0Px3TW_timeTracker__manualControls",
  "timeTracker__modeTabs": "_0Px3TW_timeTracker__modeTabs",
  "timeTracker__note": "_0Px3TW_timeTracker__note",
  "timeTracker__primaryAction": "_0Px3TW_timeTracker__primaryAction",
  "timeTracker__status": "_0Px3TW_timeTracker__status",
  "timeTracker__stopped": "_0Px3TW_timeTracker__stopped",
  "timeTracker__task": "_0Px3TW_timeTracker__task",
  "timeTracker__timeInput": "_0Px3TW_timeTracker__timeInput",
  "timeTracker__timerControls": "_0Px3TW_timeTracker__timerControls",
});
